import {FigureMainClass} from "./figureMainClass";
import {MapPosition} from "../../models/MapPosition";
import {from} from "rxjs";

export class Circle extends FigureMainClass{

  private _center : MapPosition;
  private _radius : number;
  private _color: string;
  private _opacity: number;

  get center() { return this._center; }
  set center(val) {
    this._center = val;
    this.setObjectConfigValue('center', this._center);
  }

  get radius() { return (this._radius ? this._radius : .1); }
  set radius(val) {
    this._radius = val;
    this.setObjectConfigValue('radius', this._radius);
  }

  get color() { return this._color; }
  set color(val) { this._color = val; }
  get opacity() { return this._opacity; }
  set opacity(val) { this._opacity = val; }

  __init(config) {
    this._center = new MapPosition(config.center);
    this._radius = config.radius;
    this._color = config.fillColor;
    this._opacity = config.getFillOpacity();
  }

  protected __onServerUpdate(config) {
    if (!this._center.equals(config.getCenter())) {
      this._center = config.getCenter();
      this.view.moveCircle(this.viewEntityId, this.center)
    }

    if (this._radius != config.getRadius()) {
      this._radius = config.getRadius();
      this.view.changeCircleRadius(this.viewEntityId, this.radius)
    }
  }

  public draw() {
    return from(new Promise((resolve, reject)=> {
      return this.view.drawCircle(
        this.tool,
        this,
        (entityId) => { this.setViewEntityId(entityId); resolve(entityId); }
      );
    }));
  }

  public onDragEnd(object: {position, id}){
    this._dragEnd.next({oldPosition: null, object:object});
    this.center = object.position;
  }

  public centerOnObject(){
    this.view.centerOnEntity(this.viewEntityId, this.center);
  }

  getLinkedObjectsAnchorPosition(){
    return this.center;
  }

  public startEdit(){
    this.view.editCircle(this,(entity, radius)=>{
      // this.path = positions;
      this.radius = radius;
      this.editStop.next(1);
    });
  }

  public rotate(degrees) {}

  public moveBy(offset) {

      let newPosition = new MapPosition({
        latitude: this.center.latitude + offset.latitude,
        longitude: this.center.longitude + offset.longitude
      });
      this.view.moveCircle(this.viewEntityId, newPosition);

      let object = {
        position: newPosition,
        id: this.viewEntityId
      };

      this.onDragEnd(object);
  }
}
